export enum PageLevelTypes {
    APIKEY = 'APIKEY',
    WORKFLOW = 'WORKFLOW'
}